var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCartFilledM(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 28h-14a1 1 0 01-.94-.67L7.08 9H3.5a1 1 0 010-2h4.29a1 1 0 01.94.67L11 14h22.5a1 1 0 01.83.45 1 1 0 01.09.93l-5 12a1 1 0 01-.92.62zm-13 1a2 2 0 102 2 2 2 0 00-2-2zm12 0a2 2 0 102 2 2 2 0 00-2-2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h40v40H0z"
  })));
}

export default SvgIconCartFilledM;